import { useEffect, useState } from "react";

import { appCRUD } from "../../../../actions/app";
import { TableShared } from "../../../../shared";
import { char } from "../../../../utils";
import { Button, Dropdown, Space } from "antd";
import { MoreOutlined, EyeOutlined } from "@ant-design/icons";
import { useNotification } from "../../../../utils/notificationProvider";
import { useNavigate } from "react-router-dom";
import moment from "moment";

export const SemisterData = (props) => {
    const { dataId, academicId } = props;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [postsPerPage, setePostPerPage] = useState(10);
  const [nextPage, setNextPage] = useState(0);
  const [value, setValue] = useState("");
  const [index, setIndex] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [sortType, setSortType] = useState("");
  const openNotification = useNotification();
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      appCRUD
        .loadSemister(postsPerPage, nextPage, dataId, value, "-name")
        .then((resp) => {
          setData(resp.data.results);
          setCount(resp.data.count);
        })
        .catch((error) => {
          openNotification(
            "error",
            "Error",
            <>
              Sorry...!
              <br />
              {error.message}
            </>
          );
        })
        .finally(() => {
          setLoading(false);
        });
    }, 500);
  }, [page, postsPerPage, value, index, nextPage, dataId]);

  const defaultColumns = [
    {
      key: "sn",
      title: "#",
      dataIndex: "sn",
      fixed: true,
      width: 50,
    },
    {
      key: "code",
      title: "Number",
      dataIndex: "code",
      sortable: true,
      width: 80,
    },
    {
      key: "name",
      title: "Semister Name",
      dataIndex: "name",
      sortable: true,
      width: 150,
    },
    {
      key: "start",
      title: "Start Date",
      dataIndex: "start",
      sortable: true,
      width: 150,
    },
    {
      key: "end",
      title: "End Date",
      dataIndex: "end",
      sortable: true,
      width: 150,
    },
    {
      key: "end_reg",
      title: "End of Registration",
      dataIndex: "end_reg",
      sortable: true,
      width: 150,
    },
    {
      key: "startExam",
      title: "Start of Exam",
      dataIndex: "startExam",
      sortable: true,
      width: 150,
    },
    {
      key: "endExam",
      title: "End of Exam",
      dataIndex: "endExam",
      sortable: true,
      width: 150,
    },
    {
      key: "status",
      title: "Status",
      dataIndex: "status",
      sortable: true,
      width: 80,
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 50,
      render: (record) => (
        <Dropdown
          menu={{
            items: [
              {
                label: "View",
                key: "view",
                icon: <EyeOutlined />,
              },
            ],
            onClick: (event) => {
              switch (event.key) {
                case "view":
                  navigate("/school", {
                    state: { page: "details", dataId: record.id },
                  });
                  break;
                default:
              }
            },
          }}
          placement="bottomRight"
          arrow={{ pointAtCenter: true }}
        >
          <Space>
            <Button type="dashed" icon={<MoreOutlined />} size={"small"} />
          </Space>
        </Dropdown>
      ),
    },
  ];

  const dataItem = data?.map((dt, i) => ({
    id: dt.id,
    sn: i + 1,
    code: dt.code ? dt.code : "N/A",
    name: dt.name ? char.toTitleCase(dt.name) : "N/A",
    start: dt.start_date
      ? moment(dt.start_date).format("ddd, DD MMM YYYY")
      : "N/A",
    end: dt.end_date ? moment(dt.end_date).format("ddd, DD MMM YYYY") : "N/A",
    end_reg: dt.end_registration
      ? moment(dt.end_registration).format("ddd, DD MMM YYYY")
      : "N/A",
    startExam: dt.start_exam
      ? moment(dt.start_exam).format("ddd, DD MMM YYYY")
      : "N/A",
    endExam: dt.end_exam
      ? moment(dt.end_exam).format("ddd, DD MMM YYYY")
      : "N/A",
    status: dt?.is_active ? (
      <span className="badge badge-soft-success badge-border">{"Active"}</span>
    ) : (
      <span className="badge badge-soft-danger badge-border">{"Inactive"}</span>
    ),
  }));

  const handleSemister = () => {
    setLoading(true);
    setTimeout(() => {
      appCRUD
        .addSemister(academicId)
        .then(() => {
          openNotification(
            "success",
            "Success",
            <>
              🎉 Congratulations...!
              <br />
              Semister has been successfully saved...!
            </>
          );
          setIndex(index + 1);
        })
        .catch((error) => {
          openNotification(
            "error",
            "Error",
            <>
              Oops...!
              <br />
              Something went wrong. Please try again.
            </>
          );
        })
        .finally(() => {
          setLoading(false);
        });
    }, 1000);
  };

  const button = (
    <button
      className="btn btn-primary bg-gradient btn-border"
      onClick={handleSemister}
    >
      <span className="bi bi-plus-circle la-lg"></span> &nbsp; New Semister
    </button>
  );

  return (
    <>
        <TableShared
          loading={loading}
          data={dataItem}
          setData={setData}
          page={page}
          setPage={setPage}
          count={count}
          postsPerPage={postsPerPage}
          setePostPerPage={setePostPerPage}
          setNextPage={setNextPage}
          value={value}
          setValue={setValue}
          defaultColumns={defaultColumns}
          button={button}
          link={"#"}
          showButton={true}
          sortColumn={sortColumn}
          setSortColumn={setSortColumn}
          sortType={sortType}
          setSortType={setSortType}
          setLoading={setLoading}
        />
    </>
  );
};
